// extracted by mini-css-extract-plugin
export default {"radio-item":"radio-item_radio-item__piJb7","top":"radio-item_top__5zVhZ","text":"radio-item_text__mY+MA","content":"radio-item_content__AbIoU"};